module.exports = __webpack_public_path__ + "img/alipay-example.1d688277.png";